import styled from 'styled-components';

import { BORDER, COMMON, FLEX, LAYOUT, POSITION } from '../theme/constants';
import sx, { SxProp } from '../theme/utils/sx';
import { ComponentProps } from '../utils/types';
import StyledBoxProps from './types';

const Box = styled.div<StyledBoxProps & SxProp>`
  ${COMMON}
  ${FLEX}
  ${LAYOUT}
  ${BORDER}
  ${POSITION}
  ${sx};
`;

export type BoxProps = ComponentProps<typeof Box>;
export default Box;
